// extracted by mini-css-extract-plugin
module.exports = {"root":"SvgIcon_root__FjyGt"};